import * as z from "zod";

const aggregateArm = z.object({
  arm: z.enum(["imessage", "sms_forced"]),
  enrolledCustomers: z.number(),
  dispatchesSent: z.number(),
  /** Dispatch-time routing decision, not confirmed handset delivery. */
  dispatchesViaImessage: z.number(),
  dispatchesViaSms: z.number(),
  customersWithReply: z.number(),
  replyCount: z.number(),
  /** Realized-channel reply cohorts (customer-level, disjoint). Reached-iMessage rate = withReply/reached. */
  reachedViaImessage: z.number(),
  reachedViaImessageWithReply: z.number(),
  reachedViaSmsOnly: z.number(),
  reachedViaSmsOnlyWithReply: z.number(),
});

const significance = z.object({
  pValue: z.number(),
  percentageImprovement: z.number().nullable(),
  improvementDirection: z.enum(["better", "worse", "comparable"]),
  significant: z.boolean(),
});

/** ISO date strings; omit entirely for all-time. */
const dateRange = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

/** Pooled across every active iMessage channel test, all teams. */
export const getImessageChannelExperimentAggregate = {
  name: "getImessageChannelExperimentAggregate" as const,
  /** `source` restricts pooled counts to one send surface; omit for all. */
  input: z.object({
    source: z.enum(["concierge", "recover"]).optional(),
    dateRange: dateRange.optional(),
  }),
  output: z.object({
    testCount: z.number(),
    teamCount: z.number(),
    imessage: aggregateArm,
    smsForced: aggregateArm,
    /** Null when either arm has zero enrolled customers. */
    significance: significance.nullable(),
  }),
};
